
    export interface ICreditCardPaymentProfile {
        cardNumber: number;
        cardType: any;
        expiration: Date;
        nameOnCard: string;
        cardVerificationValue: string;
    }

    export class CreditCardPaymentProfile implements ICreditCardPaymentProfile {
        cardNumber: number;
        cardType: any;
        expiration: Date;
        nameOnCard: string;
        cardVerificationValue: string;
    }
